import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import s from './style';

import iconSuccess from 'assets/images/icons/icon-success.svg';
import { useTranslation } from 'react-i18next';

const SuccessPage = () => {
  const { t } = useTranslation();
  return (
    <div className={s.PayResultWrap}>
      <div className={s.PayResult}>
        <img src={iconSuccess} alt="" className={s.PayResultIcon} />
        <div className={s.PayResultTitle}>
          {t('components.payments.successPage.title')}
        </div>
        <div
          className={s.PayResultText}
          dangerouslySetInnerHTML={{ __html: t('components.payments.successPage.description') }}
        />
        <Link to="/" className={s.PayResultButton}>
          {t('components.payments.successPage.goToMain')}
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;



// WEBPACK FOOTER //
// ./src/components/Payments/SuccessPage/SuccessPage.js